import React from 'react';
import Chart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';
import { mockEvents } from '../data/mockData';

const OccupancyChart: React.FC = () => {
  // Calcular ocupación por evento
  const eventData = mockEvents.map(event => {
    const totalStands = event.stands.reduce((sum, stand) => sum + stand.total, 0);
    const occupiedStands = event.stands.reduce((sum, stand) => sum + (stand.total - stand.available), 0);
    const occupancyRate = totalStands > 0 ? Math.round((occupiedStands / totalStands) * 100) : 0;
    
    return {
      name: event.name.split('(')[0].trim(), // Nombre corto
      occupancy: occupancyRate,
    };
  });

  const options: ApexOptions = {
    chart: {
      type: 'donut',
      height: 350,
    },
    labels: eventData.map(e => e.name),
    colors: ['#10b981', '#f59e0b', '#ef4444'],
    dataLabels: {
      enabled: true,
      formatter: (val: number) => {
        return `${val.toFixed(0)}%`;
      },
      style: {
        fontSize: '14px',
        fontFamily: 'inherit',
        fontWeight: 'bold',
      },
    },
    plotOptions: {
      pie: {
        donut: {
          size: '65%',
          labels: {
            show: true,
            name: {
              show: true,
              fontSize: '16px',
              fontFamily: 'inherit',
              fontWeight: 600,
              color: '#374151',
            },
            value: {
              show: true,
              fontSize: '24px',
              fontFamily: 'inherit',
              fontWeight: 700,
              color: '#111827',
              formatter: (val: string) => {
                return `${val}%`;
              },
            },
            total: {
              show: true,
              label: 'Ocupación Promedio',
              fontSize: '14px',
              fontFamily: 'inherit',
              color: '#6b7280',
              formatter: () => {
                const avg = eventData.reduce((sum, e) => sum + e.occupancy, 0) / eventData.length;
                return `${avg.toFixed(0)}%`;
              },
            },
          },
        },
      },
    },
    legend: {
      position: 'bottom',
      fontSize: '14px',
      fontFamily: 'inherit',
      labels: {
        colors: '#374151',
      },
      markers: {
        size: 6,
      },
    },
    tooltip: {
      theme: 'light',
      y: {
        formatter: (val: number) => {
          return `${val}% ocupado`;
        },
      },
    },
  };

  const series = eventData.map(e => e.occupancy);

  return (
    <div className="bg-white rounded-xl shadow-md p-6">
      <h3 className="text-xl font-bold text-gray-800 mb-4">Ocupación por Evento</h3>
      <Chart options={options} series={series} type="donut" height={300} />
    </div>
  );
};

export default OccupancyChart;
